import { render, staticRenderFns } from "./ProductCategory.vue?vue&type=template&id=3509ef1c&"
import script from "./ProductCategory.vue?vue&type=script&lang=js&"
export * from "./ProductCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\laravel\\rawal\\rawal-laravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3509ef1c')) {
      api.createRecord('3509ef1c', component.options)
    } else {
      api.reload('3509ef1c', component.options)
    }
    module.hot.accept("./ProductCategory.vue?vue&type=template&id=3509ef1c&", function () {
      api.rerender('3509ef1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/ProductCategory.vue"
export default component.exports